const columns = [
  {
    title: "تاریخ ثبت",
    dataIndex: "createdAt",
    key: "createdAt",
    width: 130,
    sorter: true,
  },
  {
    title: "کاربر",
    dataIndex: "user",
    key: "user",
    width: 150,
    sorter: true,
    ellipsis: true,
  },
  {
    title: "مشاوره",
    dataIndex: "product",
    key: "product",
    width: 130,
  },
  {
    title: "تاریخ مشاوره",
    dataIndex: "consultationDate",
    key: "consultationDate",
    width: 130,
    sorter: true,
  },
  {
    title: "ساعت مشاوره",
    dataIndex: "consultationTime",
    key: "consultationTime",
    width: 130,
    sorter: true,
  },

  {
    title: "مکان",
    dataIndex: "place",
    key: "place",
    width: 120,
  },
  
  {
    title: "جزییات",
    dataIndex: "details",
    key: "details",
    width: 140,
  },
];

export default columns;
